export default "<carousel-element>@{}<carousel-element";